import React, { useState, useRef } from 'react';
import {
  useDispatch,
} from 'react-redux';

import ActionButton from '../../shared/components/actionButton';
import FormNotification from '../../shared/components/formNotification';
import notificationTypes from '../../shared/components/formNotification/notificationTypes';
import RecaptchaVerification from '../../shared/components/recaptchaVerification';

import {
  setSelectedForm,
  remindPassword,
} from '../actions';
import {
  FORMS__SIGN_IN,
} from '../constants';

const RemindPassword = () => {
  const recaptchaRef = useRef(null);
  const dispatch = useDispatch();
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorFieldMessage, setErrorFieldMessage] = useState(null);
  const [email, setEmail] = useState('');

  const returnButtonClick = () => {
    dispatch(setSelectedForm(FORMS__SIGN_IN));
  };

  const remindPasswordSuccess = () => {
    setIsLoading(false);
    setErrorMessage({ value: 'Email zostanie wysłany po zweryfikowaniu konta użytkownika.', type: notificationTypes.SUCCESS });
  };

  const remindPasswordFailure = (message) => {
    setIsLoading(false);
    setErrorMessage(message);
  };

  const onRecaptchaVerify = (isVerificationSuccess) => {
    if (isVerificationSuccess) {
      setSubmitButtonDisabled(false);
    } else {
      setSubmitButtonDisabled(true);
    }
  };

  const remindPasswordButtonClick = () => {
    if (!email) {
      setErrorFieldMessage('Pole wymagane');
    } else {
      setIsLoading(true);
      setErrorFieldMessage(null);
      dispatch(remindPassword(email, remindPasswordSuccess, remindPasswordFailure));
    }
  };

  const onFormClick = (event) => {
    if (event.key === 'Enter') {
      remindPasswordButtonClick();
    }
  };

  return (
    <div className="remind-password">
      <div className="title">
        Podaj swój e-mail
      </div>
      <div className="description">
        Jeśli zapomniałeś hasła do swojego konta, to wystarczy, że podasz swój e-mail, a my wyślemy Ci link do zmiany hasła.
      </div>
      <div className="form" onKeyDown={onFormClick} role="button">
        <div className="form-group">
          <FormNotification message={errorMessage} />
          <div className="error-message">
            {errorFieldMessage}
          </div>
          <label htmlFor="email">
            <div className="required-label-field">
              E-mail
            </div>
            <input
              className="form-control"
              id="email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </label>
        </div>
      </div>
      <RecaptchaVerification
        className="form-group"
        onRecaptchaVerify={onRecaptchaVerify}
        recaptchaRef={recaptchaRef}
      />
      <div className="actions">
        <ActionButton
          title="Resetuj hasło"
          onClick={remindPasswordButtonClick}
          isLoading={isLoading}
          disabled={submitButtonDisabled}
        />
        <div
          className="button return-button float-right"
          onClick={returnButtonClick}
          role="button"
          title="Powrót"
        >
          Powrót
        </div>
      </div>
    </div>
  );
};

export default RemindPassword;
